import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CaseTypeRepository } from '../../../infrastructure/repositories/case-type.repository';
import { CaseTypeState } from '../../states/case-type.state';
import { GetAllCaseTypesResult } from './get-all-case-types.result';

/**
 * GetAllCaseTypes use case.
 * Orchestrates retrieving all case types and manages application state.
 */
@Injectable({ providedIn: 'root' })
export class GetAllCaseTypesUseCase {
  private readonly caseTypeRepository = inject(CaseTypeRepository);
  private readonly caseTypeState = inject(CaseTypeState);

  /**
   * Executes the getAllCaseTypes use case.
   * @param _query - Query parameters (currently unused)
   * @returns Observable with case types result
   */

  public execute(): Observable<GetAllCaseTypesResult> {
    this.caseTypeState.setLoading(true);
    this.caseTypeState.clearError();

    return this.caseTypeRepository.getAllCaseTypes().pipe(
      tap((caseTypes) => {
        this.caseTypeState.setCaseTypes(caseTypes);
        this.caseTypeState.setLoading(false);
      }),
      map((caseTypes) => ({ caseTypes })),
      catchError((error) => {
        this.caseTypeState.setError(error?.error?.message || error?.message || 'Failed to load case types');
        throw error;
      }),
    );
  }
}
